import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Building2 } from 'lucide-react'
import { workspacesQueryOptions } from '@/lib/queryOptions'
import { api } from '@/lib/api'

export function WorkspaceSwitcher() {
  const qc = useQueryClient()
  const { data } = useQuery(workspacesQueryOptions())

  const switchMutation = useMutation({
    mutationFn: api.workspaces.switch,
    onSuccess: async () => {
      await qc.invalidateQueries()
    },
  })

  const workspaces = data?.workspaces ?? []
  const activeWorkspaceId = data?.activeWorkspaceId ?? ''

  if (workspaces.length === 0) return null

  return (
    <div className="flex items-center gap-2">
      <Building2 size={14} className="text-white/45" />
      <select
        value={activeWorkspaceId}
        onChange={(e) => switchMutation.mutate(e.target.value)}
        className="glass px-3 py-1.5 rounded-lg text-xs text-white bg-transparent focus:outline-none focus:ring-2 focus:ring-[var(--oc-accent)]/60 min-w-44"
        disabled={switchMutation.isPending}
      >
        {workspaces.map((workspace) => (
          <option key={workspace.id} value={workspace.id} style={{ background: '#1a1a2e' }}>
            {workspace.name} ({workspace.workspaceType === 'SHARED_OPS' ? 'Ops' : workspace.role})
          </option>
        ))}
      </select>
    </div>
  )
}
